import { render, staticRenderFns } from "./FixedPlans.vue?vue&type=template&id=22fa58df&scoped=true"
import script from "./FixedPlans.vue?vue&type=script&lang=js"
export * from "./FixedPlans.vue?vue&type=script&lang=js"
import style0 from "./FixedPlans.vue?vue&type=style&index=0&id=22fa58df&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fa58df",
  null
  
)

export default component.exports